<template>
  <div id="prof_main">
  
<div id="mySidebar" class="sidebar">
  <a href="javascript:void(0)" class="closebtn" @click="closeNav()">&times;</a>
  <a @click="main_show"><span class="icon"><i class="fas fa-home"></i></span> &nbsp;Main</a>
  <!-- <a @click="courses_show()"><span class="icon"><i class="fas fa-list"></i></span> &nbsp;Courses</a> -->
  <a @click="schedule_show()"><span class="icon"><i class="fas fa-calendar-alt"></i></span> &nbsp;Schedule</a>
  <a>--------------</a>
  <a @click="logout"><span class="icon"><i class="fas fa-sign-out-alt"></i></span> &nbsp;Log out</a>
  
</div>

<div id="main">

<div class="columns is-gapless is-mobile">
  <div class="column is-2"><button class="openbtn" @click="sortNav()">&#9776;</button></div>
  <div class="column is-10 is-size-4">{{active_college}}</div>
</div>




<!-- STUD!!!!  -->


<section v-if="show_main" class="hero">
  <div class="hero-body">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-8">
          <div class="box has-background-light">
            <div class="columns is-gapless is-multiline is-mobile">
              <div class="column is-12 doFont">{{prof_name}}</div>
              



<div class="column is-12">
<div class="columns">
<!-- <div @click="courses_show()" class="column menu_wrapper is-3 is-size-6 has-text-centered" style="margin-top:3em;"><span class="icon"><i class="fas fa-list-alt"></i></span> &nbsp;COURS/NOTES </div> -->
<div @click="schedule_show()" class="column menu_wrapper is-3 is-size-6 has-text-centered" style="margin-top:3em;"><span class="icon"><i class="fas fa-calendar-alt"></i></span> &nbsp;CALENDRIER </div>

<div @click="show_password=!show_password" class="column menu_wrapper is-3 is-size-6 has-text-centered" style="margin-top:3em;"><span class="icon"><i class="fas fa-lock"></i></span> &nbsp;MOT DE PASSE </div>
</div></div>



<div v-if="show_password" class="column is-12">
<div class="columns box is-multiline has-background-grey-dark has-text-white">

  <div class="column is-6">Password<input v-model="pass1" class="input is-fullwidth" type="password" placeholder="...." ></div>
  <div class="column is-6">Retype Password<input v-model="pass2" class="input is-fullwidth" type="password" placeholder="...."></div>
  <div class="column is-12"><button @click="save_password()" class="button is-success">Save</button></div>

  <div class="column is-12">{{password_error}}</div>

</div>
</div> 


            </div>
          </div>
        </div>
      </div>






    </div>
  </div>
</section>


<!-- <CompSchedule v-if="show_schedule"
  :prof_id="prof_id"
> </CompSchedule>
 -->

<Calendar v-if="show_schedule" :events="events" style="margin-top:-2.0em;"
> </Calendar>

</div>

</div>
</template>


<script>
import axios from 'axios';
import moment from 'moment'
//import  CompSchedule  from '@/views/Prof/Schedule'
import Calendar from '@/components/Comp_Calendar'

export default {
  components: { Calendar },

  data: function() {
    return {
      data_student: '',
      navOpen:false,

events:[],

active_college : sessionStorage.getItem('college') ,
prof_id : sessionStorage.getItem('user_ID') ,
prof_name : sessionStorage.getItem('user_name') ,

show_main :true,
show_schedule :false,
show_courses :false,


show_password:false,
password_error:'',
pass1:'',
pass2:'',



    }
  },


created() {

// GET PROF SCHEDULE
  var query = `SELECT myMEQ_SCHEDULE_MAIN.*,myMEQ_SCHEDULE_ROOM.schedRoom_DESC,schedRoom_CAMPUS, MyMEQ_STAFF.staff_Prenom + ' ' + MyMEQ_STAFF.staff_Nom AS prof , DATEADD(day, 1, schedMain_date) AS DateAdd
  FROM  myMEQ_SCHEDULE_MAIN 
  LEFT OUTER JOIN myMEQ_SCHEDULE_ROOM ON myMEQ_SCHEDULE_MAIN.schedRoom_ID = myMEQ_SCHEDULE_ROOM.schedRoom_ID LEFT OUTER JOIN  MyMEQ_STAFF ON myMEQ_SCHEDULE_MAIN.staff_ID = MyMEQ_STAFF.staff_ID 
  WHERE myMEQ_SCHEDULE_MAIN.staff_ID = ` + this.prof_id + ` ORDER BY schedMain_AmPmSoir`
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        var i;
        for (i = 0; i < res.data.length; i++) {
          this.events.push( 
            { 
              title: res.data[i].schedMain_AmPmSoir + " : " + res.data[i].schedMain_CODE_COUR + " : " + res.data[i].schedMain_CODE_PROF,
              details: 'COUR : ' + res.data[i].schedMain_CODE_COUR + '<br>' + 'PROF : ' + res.data[i].prof + '<br>' + 'TIME : ' + res.data[i].schedMain_AmPmSoir + '<br>SALLE : ' + res.data[i].schedRoom_DESC + '<br><b>' + res.data[i].schedRoom_CAMPUS + '</b>',
              date: moment(res.data[i].DateAdd).format('YYYY-MM-DD'),
              open: false,
              class:'my-event',
              color: res.data[i].schedMain_COLOUR,
              hour:res.data[i].schedMain_AmPmSoir
            })
        } // END FOR
    })
}, // ------------ END CREATED 

  methods: {

save_password() {
  this.password_error = ''

if (!this.pass1 || !this.pass2) {this.password_error = 'Enter New Password'; return}
if (this.pass1 != this.pass2) {this.password_error = 'Passwords Do Not Match'; return}


    var sql = "UPDATE  MyMEQ_STAFF SET staff_PASSWORD = '" + this.pass1 + "' WHERE staff_ID = " + sessionStorage.getItem('user_ID')
    sql += ";SELECT staff_ID FROM MyMEQ_STAFF WHERE staff_ID = "  + sessionStorage.getItem('user_ID') 
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + sql)
    .then(res => {
        this.show_password=false 
    })

  
},


main_show () {
  this.show_main = true
  this.show_schedule = false
  this.show_courses = false
  

  this.closeNav()
},
schedule_show () {
  this.show_main = false
  this.show_schedule = true
  this.show_courses = false
  
  this.closeNav()
},

courses_show () {
  this.show_main = false
  this.show_schedule = false
  this.show_courses = true
  
  this.closeNav()
},

logout:function() {
        sessionStorage.removeItem('user_ID')
        sessionStorage.removeItem('isGood')
        sessionStorage.removeItem('user_level')
        this.$router.push({ name: 'main' });  
},



sortNav() {
    if (this.navOpen) {this.closeNav()} else {this.openNav()}
    
},

openNav() {
  document.getElementById("mySidebar").style.width = "250px";
  document.getElementById("main").style.marginLeft = "250px";
  this.navOpen = true
},

/* Set the width of the sidebar to 0 and the left margin of the page content to 0 */
closeNav() {
  document.getElementById("mySidebar").style.width = "0";
  document.getElementById("main").style.marginLeft = "0";
  this.navOpen = false
},



      chkLoggedIn:function(){
        if (sessionStorage.getItem('isGood') === null) {return false } else { return true  }
      },
  }
}
</script>




<style scoped>

.menu_wrapper {
  background-color: white;
  border: thin solid TAN;
  font-weight: 900;
  cursor:pointer;
}
.menu_wrapper:hover {
  background-color: AZURE;
  border: medium solid ROSYBROWN;
}




</style>
